// src/components/FAQSection.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Reusable FAQ block with JSON-LD (FAQPage).
 * Usage: <FAQSection items={[{ q: "...", a: "..." }, ... ]} />
 */
export default function FAQSection({ items = [] }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": items.map(({ q, a }) => ({
      "@type": "Question",
      "name": q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": a
      }
    }))
  };

  return (
    <section id="faq" style={{ maxWidth: 900, margin: "24px auto", padding: "0 16px" }}>
      <h2 style={{ fontSize: 22, marginBottom: 12 }}>FAQ</h2>

      <div>
        {items.map(({ q, a }, i) => (
          <details key={i} style={{
            background: "#f8fafc",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            padding: "12px 14px",
            marginBottom: 10
          }}>
            <summary style={{ fontWeight: 600, cursor: "pointer" }}>{q}</summary>
            <p style={{ marginTop: 8, lineHeight: 1.6 }}>{a}</p>
          </details>
        ))}
      </div>

      {/* JSON-LD for rich results */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
    </section>
  );
}
